import { mapApiPlatformToAdapted } from 'utils';

export const resourceItemAdapter = (item, platform) => {
  return {
    avatar: item?.avatar,
    title: item?.title ?? item?.name ?? item?.full_name ?? null,
    platform: platform,
    contentPlatform:
      platform === 'nativePlatforms'
        ? mapApiPlatformToAdapted(item.platform)
        : null,
    id: item?.id,
    username:
      (!['news', 'newspaper'].includes(platform) ? '@' : '') +
      (platform === 'news' || platform === 'newspaper'
        ? item?.url
        : item?.username),
    count:
      platform === 'telegram' || platform === 'nativePlatforms'
        ? item?.member_count
        : item?.follower_count || null,
  };
};
